// Enter new password and reset it
<template>
  <div class="flex items-center min-h-screen w-full">
    <div
      class="w-full bg-white rounded shadow-lg p-8 m-4 md:max-w-sm md:mx-auto"
    >
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <div class="flex items-center">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              ></path>
            </svg>
            <div class="text-right text-xl cobalt-text-color">
              Reset Password
            </div>
          </div>
          <form class="mt-4 space-y-6" @submit.prevent="submit" novalidate>
            <div
              ref="errorSummary"
              class="sr-only"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
            >
              {{ errorSummary }}{{ announceNonce }}
            </div>
            <div class="rounded-sm">
              <div class="flex flex-col mt-2">
                <text-input
                  label="Verification Code"
                  id="otp_code"
                  :class="{ 'border-red-400': v$.form.otp_code.$error }"
                  v-bind:value="form.otp_code"
                  @blur="v$.form.otp_code.$touch()"
                  helptext="Must be at least 8 characters and contain a lowercase & uppercase character with a special character and a number."
                  v-on:keyup="form.otp_code = $event.target['value']"
                ></text-input>

                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.otp_code.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'minLength'">
                    Enter minimum six letters
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                  label="Password"
                  id="password"
                  :type="show ? 'password' : 'text'"
                  showIcon="true"
                  showIcon1="true"
                  @showHide="show = !show"
                  :class="{ 'border-red-400': v$.form.password.$error }"
                  v-bind:value="form.password"
                  @blur="v$.form.password.$touch()"
                  helptext="Must be at least 8 characters and contain a lowercase & uppercase character with a special character and a number."
                  v-on:keyup="form.password = $event.target['value']"
                ></text-input>

                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.password.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'password'">
                    Please enter valid password
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="confirm_password"
                  label="Confirm Password"
                  :type="show1 ? 'password' : 'text'"
                  showIcon="true"
                  showIcon1="true"
                  @showHide="show1 = !show1"
                  @blur="v$.form.confirm_password.$touch()"
                  :class="{ 'border-red-400': v$.form.confirm_password.$error }"
                  v-bind:value="form.confirm_password"
                  v-on:keyup="form.confirm_password = $event.target['value']"
                ></text-input>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.confirm_password.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'sameAsPassword'">
                    Passwords must match
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button
                id="reset_password"
                type="submit"
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                aria-required="true"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    ></path>
                  </svg>
                </span>
                Reset Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue";
import useVuelidate from "@vuelidate/core";
import { required, sameAs,minLength} from "@vuelidate/validators";
import { helpers } from "vuelidate/lib/validators";
const password = helpers.regex(
  "password",
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
);
// import { mapState } from "vuex";
export default {
  name: "Reset Password",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data: function() {
    return {
      show: true,
      show1: true,
      form: {},
      email:'',
      errorSummary: "",
      announceTick: 0,
      announceNonce: ""
    };
  },
  validations() {
    return {
      form: {
        otp_code:{
          minLength: minLength(6),
          required
        },
        password: {
          required,
          password,
        },
        confirm_password: {
          required,
          sameAsPassword: sameAs(this.form.password),
        },
      },
    };
  },
  mounted() {
    this.email=localStorage.getItem('forgot_email');
    if(this.email=="" || this.email==null || this.email==undefined){
      this.$router.push("/unauthorized");
    }
  },
  methods: {
    fieldLabelMap() {
      return {
        otp_code: "Verification Code",
        password: "Password",
        confirm_password: "Confirm Password",
      };
    },
    announceErrors() {
      const errors = this.v$?.form?.$errors || [];
      if (!errors.length) {
        this.errorSummary = "";
        return;
      }
      const labels = this.fieldLabelMap();
      const messages = errors
        .map((e) => {
          const key = e?.$property || e?.$propertyPath;
          const label = (key && labels[key]) || key || "Field";
          const msg = e?.$message || "Invalid value";
          return `${label}: ${msg}`;
        })
        .filter((m) => !!m);
      this.announceTick += 1;
      this.announceNonce = this.announceTick % 2 === 0 ? "\u200B" : "\u200C";
      this.errorSummary = "";
      this.$nextTick(() => {
        this.errorSummary = `Please correct the following errors. ${messages.join(". ")}.`;
      });
    },
    submit: function() {
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) {
        this.announceErrors();
        return;
      }
      this.form.email=this.email;
      this.$store.dispatch("resetPassword", this.form).then((result) => {
        console.log(result)
        localStorage.removeItem('forgot_email');
        this.$toast.success("Password reset successfully, you can login now!!");
        this.$router.push("/login");
        })
        .catch((error) => {
          this.$toast.error(error);
         console.log(error)
        });
    },
  },
};
</script>
